import { BodyLarge400 } from '@nebula/global-styles';
import React, { useState, useEffect, useContext } from 'react';
import Spinner from '@nebula/spinner';
import PropTypes from 'prop-types';
import { LoaderContainer, VisuallyHiddenStatus, SpinnerContainer } from './loader.styles';
import { PaymentContext } from '../../../components/PaymentOrchestrator/PaymentContextProvider';

const Loader = ({ text = '' }) => {
  const { isWebview } = useContext(PaymentContext);
  const [announcement, setAnnouncement] = useState(text);

  useEffect(() => {
    if (!text) {
      return undefined;
    }
    const interval = setInterval(() => {
      setAnnouncement(prev => (prev === text ? `${text}.` : text));
    }, 2000);

    return () => clearInterval(interval);
  }, [text]);

  return (
    <LoaderContainer isWebview={isWebview} tabIndex={0}>
      {text && (
        <VisuallyHiddenStatus aria-live="assertive" aria-atomic="true">
          {announcement}
        </VisuallyHiddenStatus>
      )}
      <SpinnerContainer>
        <Spinner spinnerSize="44px" />
        {text && <BodyLarge400>{text}</BodyLarge400>}
      </SpinnerContainer>
    </LoaderContainer>
  );
};

Loader.propTypes = {
  text: PropTypes.string,
};

export default Loader;
